export enum FlutterHandler {
  SyncData = 'syncEmbedData',
  StartPassive = 'startPassiveMediaRecording',
  StopPassive = 'stopPassiveMediaRecording',
  OpenMedia = 'openMediaAction',
  GetPosition = 'getPosition',
  OpenVideo = 'OpenVideo',
}

export enum MediaActionType {
  Camera = 'camera',
  Video = 'video',
  Audio = 'audio',
  PickImage = 'pick_image',
  PickVideo = 'pick_video',
}

export enum FlutterMessageTypes {
  IMAGE_SAVED = 'fa-image-saved',
  VIDEO_SAVED = 'fa-video-saved',
  AUDIO_SAVED = 'fa-audio-saved',

  RECIEVE_LOCATION = 'fa-position',

  PASSIVE_MEDIA = 'pa_media_save',
  OPEN_CAMERA = 'af-open-camera',

  RESPONSE_SYNC = 'af-response-sync',

  VIDEO_PLAYBACK_DONE = 'fa-video-playback-done',
}

/**
 * The core bridge function.
 * Checks for Flutter availability and calls the requested handler.
 */
export const emitToFlutter = async <T = any>(
  handler: FlutterHandler,
  payload: any = null,
): Promise<T | null> => {
  const bridge = (window as any).flutter_inappwebview;
  if (!bridge?.callHandler) {
    console.warn(
      `[FlutterBridge] "${handler}" ignored. Not in Flutter environment.`,
    );
    return null;
  }

  try {
    // Flutter expects: handlerName, ...args
    // We pass our payload as the first argument so it arrives as args[0] in Dart
    return await bridge.callHandler(handler, payload);
  } catch (error) {
    console.error(`[FlutterBridge] Error in ${handler}:`, error);
    throw error;
  }
};

export const isFlutter = (): boolean =>
  !!(window as any).flutter_inappwebview?.callHandler;

// 1. Sync Session
export const syncFlutterSession = (sessionData: any) =>
  emitToFlutter(FlutterHandler.SyncData, sessionData);

// 2. Passive Controls
export const togglePassiveRecording = (start: boolean) =>
  emitToFlutter(
    start ? FlutterHandler.StartPassive : FlutterHandler.StopPassive,
  );

// 3. Media Actions (Type-safe)
export const triggerMedia = (type: MediaActionType, extra: object = {}) =>
  emitToFlutter(FlutterHandler.OpenMedia, { type, ...extra });

// 4. Utils
export const getFlutterLocation = () =>
  emitToFlutter(FlutterHandler.GetPosition);

export const openFlutterAssetVideo = (url: string) =>
  emitToFlutter(FlutterHandler.OpenVideo, url);
